import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-expect-error no types from package
import { getCookie } from 'hub-http/helpers/cookies'; // @ts-expect-error folder not yet converted to TS

import { trackSmartLoginOptOut } from '../../lib/tracker';
import UIAlert from 'UIComponents/alert/UIAlert';
import { SMART_LOGIN_COOKIE } from '../../constants/SmartLogin';
import styled from 'styled-components';
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UILink from 'UIComponents/link/UILink'; // import enviro from 'enviro';

import UIFlex from 'UIComponents/layout/UIFlex';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getDomain } from '../../utils/urls';
const StyledContainer = styled.div.withConfig({
  displayName: "BetaLoginBanner__StyledContainer",
  componentId: "ongp1v-0"
})(["max-width:425px;margin-top:10px;margin-bottom:48px;"]);
export default function BetaLoginBanner() {
  const [visible, setVisible] = useState(false);

  const optOut = () => {
    // Cookie should expire immediately
    const domain = getDomain();
    const userEmail = getCookie(SMART_LOGIN_COOKIE, document.cookie);
    document.cookie = `${SMART_LOGIN_COOKIE}=false;Path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=${domain}`;
    trackSmartLoginOptOut(userEmail);
    window.location.href = `/login${window.location.search}`;
  };

  const location = useLocation();
  useEffect(() => {
    setVisible(location.pathname.startsWith('/beta'));
  }, [location]);
  return visible ? /*#__PURE__*/_jsx(UIFlex, {
    align: "center",
    justify: "center",
    direction: "column",
    children: /*#__PURE__*/_jsx(StyledContainer, {
      children: /*#__PURE__*/_jsxs(UIAlert, {
        titleText: I18n.text('login.smartLogin.betaBanner.title'),
        type: "info",
        children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "login.smartLogin.betaBanner.description_jsx",
          options: {
            onClick: optOut,
            size: 'extra-small'
          },
          elements: {
            Link: UILink
          }
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
          className: "m-y-1",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "login.smartLogin.betaBanner.feedbackButton"
          })
        })]
      })
    })
  }) : /*#__PURE__*/_jsx(_Fragment, {});
}